module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("15")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Hier bin")]), _vm._v(" ich, dir Lieder\nzu singen."), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nIn deiner Halle hab ich den Sitz im Winkel.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("In deiner Welt hab ich kein Werk zu"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ntun, mein nutzlos Leben kann nur ausströmen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nzwecklos in Tönen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wenn die Stunde schlägt für deinen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nschweigenden Dienst im dunkeln Tempel"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nder Mitternacht, befiehl mir, mein"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nMeister, vor dir zu stehn und zu singen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wenn in der Morgenluft die goldene"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nHarfe gestimmt ist, ehre mich und befiehl"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nmir, vor dich zu treten. "), _c('a', {
    attrs: {
      "id": "page20",
      "title": "Wunibald/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25d6ccc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0016.vue
// module id = 102
// module chunks = 0